import React from 'react';
import styled from 'styled-components/native';
import { View, Platform } from 'react-native';
import PropTypes from 'prop-types';
import Colors from '../colors';
import Text from '../text';
import Icon from '../icon';
import Spacer from '../spacer';
const StyledBackground = styled.Pressable`
  background-color: ${Colors.white};
  border: 1px solid transparent;
  border-bottom-color: ${Colors.lightGray300};
  min-height: ${props => props.height}px;
  justify-content: center
`;
const StyledImage = styled.Image`
  width: 32px;
  height: 32px;
`;
const Row = styled.View`
  flex-direction: row;
  align-items: center;
`;
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const StyledRowLeft = styled.View`
  display: inline-block;
  -webkit-flex: 1;
  padding: 15px 0;
`;
const TYPES = {
  default: {
    text: Text.BodyBase,
    height: 56
  },
  small: {
    text: Text.BodyExtraSmall,
    height: 40
  },
  label: {
    text: Text.BodySmall,
    height: 68
  }
};
const ROWS = {
  'no-side-padding': StyledRowLeft,
  default: Row
};
export default function ListItem(props) {
  const type = TYPES[props.type];
  const TextComponent = type.text;
  const Height = type.height;
  const LeftRow = props.noSidePadding ? ROWS['no-side-padding'] : ROWS.default;
  return /*#__PURE__*/React.createElement(StyledBackground, {
    height: Height,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(LeftRow, null, !props.noSidePadding && /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  }), props.imgSrc !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, Platform.select({
    web: /*#__PURE__*/React.createElement(StyledImage, {
      source: {
        uri: props.imgSrc
      }
    }),
    default: /*#__PURE__*/React.createElement(StyledImage, {
      source: props.imgSrc
    })
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  })), /*#__PURE__*/React.createElement(View, null, props.type === 'label' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.gray400
  }, props.description), /*#__PURE__*/React.createElement(Spacer, {
    size: "f2",
    height: true
  })), /*#__PURE__*/React.createElement(TextComponent, {
    weight: props.type === 'label' && 'medium',
    color: Colors.gray600
  }, props.children), props.type === 'default' && /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.gray400
  }, props.description))), /*#__PURE__*/React.createElement(Row, null, props.buttonLabel === '' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "chevron-right",
    size: 24,
    color: Colors.purple400
  }), !props.noSidePadding && /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    width: true
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.purple400,
    weight: "medium"
  }, props.buttonLabel), !props.noSidePadding && /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    width: true
  })))));
}
ListItem.propTypes = {
  children: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(TYPES)),
  imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonLabel: PropTypes.string,
  onPress: PropTypes.func,
  noSidePadding: PropTypes.bool
};
ListItem.defaultProps = {
  children: '',
  description: '',
  type: 'default',
  imgSrc: '',
  buttonLabel: '',
  onPress: () => {},
  noSidePadding: false
};
//# sourceMappingURL=index.js.map